"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (value, step, min) {
  var remainder = value % step;
  var prevNumber = value - remainder + min;
  var nextNumber = prevNumber + step;
  return value - prevNumber >= nextNumber - value ? nextNumber : prevNumber;
};